module.exports = __webpack_public_path__ + "static/media/404Error.8705646f.svg";